import { textoDataParaIso } from "@/utils/datas";

// TODO: PJ FUTURAMENTE TRATAR
const TIPO_PESSOA_API = "FISICA";
const SIGLA_BRASIL = "BR";

function trimIfPresent(value) {
  return value == null ? undefined : String(value).trim();
}

function trimOrNull(value) {
  if (value == null) return null;
  const t = String(value).trim();
  return t || null;
}

function passaporteNormalizado(value) {
  const t = trimIfPresent(value);
  return t == null ? undefined : t.toUpperCase();
}

export function buildUsuarioRegistroPayload(form) {
  const p = form.pessoa;
  const estr = p.estrangeiro;
  const ep = p.enderecoPrincipal;
  const ee = p.enderecoEstrangeiro;

  const pessoaFisica = {
    nome: trimIfPresent(p.nome),
    dataNascimento: textoDataParaIso(p.dataNascimentoString),
    nomeMae: trimIfPresent(p.nomeMae),
    sexo: p.sexo,
    ...(estr
      ? {
          cpf: null,
          passaporte: passaporteNormalizado(p.passaporte),
          siglaPais: p.nacionalidade == null ? undefined : p.nacionalidade.sigla
        }
      : {
          cpf: String(p.cpf || "").replace(/\D/g, "") || null,
          passaporte: null,
          siglaPais: SIGLA_BRASIL
        })
  };

  const endereco = estr
    ? {
        logradouro: trimIfPresent(ee.descricaoEndereco),
        numero: null,
        complemento: trimOrNull(ee.complemento),
        bairro: null,
        cep: trimIfPresent(ee.zipCode),
        idMunicipio: null,
        siglaPais: ee.pais == null ? undefined : ee.pais.sigla,
        municipioInternacional: trimIfPresent(ee.cidade),
        estadoInternacional: trimIfPresent(ee.estado),
        descricao: null
      }
    : {
        logradouro: trimIfPresent(ep.logradouro),
        numero: ep.semNumero
          ? null
          : ep.numero == null
          ? null
          : trimOrNull(String(ep.numero)),
        complemento: trimOrNull(ep.complemento),
        bairro: trimIfPresent(ep.bairro),
        cep: String(ep.cep || "").replace(/\D/g, ""),
        idMunicipio: ep.municipioId,
        siglaPais: SIGLA_BRASIL,
        municipioInternacional: null,
        estadoInternacional: null,
        descricao: null
      };

  return {
    senha: form.senha,
    pessoa: {
      tipo: TIPO_PESSOA_API,
      email: trimIfPresent(p.email),
      pessoaFisica,
      endereco
    }
  };
}
